import { defineStore } from 'pinia';

export const useFullSpinnerStore = defineStore('fullSpinner', {
  state: () => ({
    fullSpinner: false
  }),
  actions: {
    showFullSpinner() {
      this.fullSpinner = true;
    },
    hideFullSpinner() {
      this.fullSpinner = false;
    }
  }
});
